import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder, FormControl, AbstractControl } from '@angular/forms';
import { RxComponent } from 'app/core/components/common/rx.component';
import { ProductVariantService } from '../product-variant.service';
import { MiddlemanService } from 'app/core/services/middleman.service';
import { NotificationService } from 'app/core/services/notification.service';

declare var moment: any;

@Component({
  selector: 'itpx-product-variants-bulk-edit',
  templateUrl: './product-variants-bulk-edit.component.html',
  styleUrls: ['./product-variants-bulk-edit.component.css']
})
export class ProductVariantsBulkEditComponent extends RxComponent implements OnInit {

    @Output()
    private formChange = new EventEmitter<any>();

    private data: Array<any>;

    private form: FormGroup;

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private service: ProductVariantService,
        private middleman: MiddlemanService,
        private notificationService: NotificationService
    ) {
        super();
        this.data = this.middleman.getData();
        if(!this.data) this.router.navigate(['/agora/product-data/product-variants']);
    }

    ngOnInit() {
        this.form = this.fb.group({
            online: null,
            lastOrderDate: null,
            endOfLife: null
        });
    }

    onSubmit(formValue: any) {
        let edit = this.getFields(formValue);
        this.service.bulkEdit({ data: this.data, edit: edit })
            .subscribe(
                res => {
                    this.notificationService.success('The selected Products have been successfully updated');
                    this.router.navigate(['/agora/product-data/product-variants']);
                }
            )
    }

    getFields(data: any) {
        let result = [];
        Object.keys(data).forEach(e => {
            if(data[e] !== null) {
                if(e == 'lastOrderDate' || e == 'endOfLife') {
                    result.push({
                        key: e,
                        value: this.formatDateToUTC(data[e])
                    })
                } else {
                    result.push({
                        key: e,
                        value: data[e]
                    })
                }
            }

        })
        return result;
    }

    private formatDateToUTC(date) {
        let mDate = moment(date);
        return Date.parse(moment(mDate).utc().add(mDate.utcOffset(), 'm').format())/1000;
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-variants/product-variants-bulk-edit/product-variants-bulk-edit.component.ts